"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgMusic(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M14 32V9.851c0-.642.426-1.195 1.018-1.321l16.467-3.504c.686-.146 1.353.328 1.49 1.057.017.087.025.176.025.265L32.975 28M14 18.042L33 14", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, void 0), (0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M9.5 35c2.485 0 4.5-1.343 4.5-3s-2.015-3-4.5-3S5 30.343 5 32s2.015 3 4.5 3zM28.5 31c2.485 0 4.5-1.343 4.5-3s-2.015-3-4.5-3-4.5 1.343-4.5 3 2.015 3 4.5 3z", stroke: "currentColor", strokeWidth: 2 }, void 0)] }), void 0));
}
exports.default = SvgMusic;
//# sourceMappingURL=Music.js.map